/**
 * 全局响应式样式配置
 * 基于设备检测自动适配所有业务页面和组件
 */

// 响应式断点配置（与 Tailwind CSS 保持一致）
export const breakpoints = {
  sm: 640,   // 小屏幕（手机横屏）
  md: 768,   // 中等屏幕（平板竖屏）
  lg: 1024,  // 大屏幕（平板横屏/小笔记本）
  xl: 1280,  // 超大屏幕（桌面）
  '2xl': 1536 // 超超大屏幕（大桌面）
}

// 设备类型样式配置
export const deviceStyles = {
  mobile: {
    // 移动端样式配置
    fontSize: {
      xs: '0.625rem',   // 10px
      sm: '0.75rem',    // 12px
      base: '0.875rem', // 14px
      lg: '1rem',       // 16px
      xl: '1.125rem',   // 18px
      '2xl': '1.25rem'  // 20px
    },
    spacing: {
      xs: '0.25rem',  // 4px
      sm: '0.5rem',   // 8px
      md: '0.75rem',  // 12px
      lg: '1rem',     // 16px
      xl: '1.25rem'   // 20px
    },
    padding: {
      page: 'p-3',      // 页面内边距
      card: 'p-3',      // 卡片内边距
      section: 'p-2'    // 区块内边距
    },
    gap: {
      xs: 'gap-1',
      sm: 'gap-2',
      md: 'gap-3',
      lg: 'gap-4'
    }
  },
  tablet: {
    // 平板样式配置
    fontSize: {
      xs: '0.75rem',    // 12px
      sm: '0.875rem',   // 14px
      base: '1rem',     // 16px
      lg: '1.125rem',   // 18px
      xl: '1.25rem',    // 20px
      '2xl': '1.5rem'   // 24px
    },
    spacing: {
      xs: '0.375rem', // 6px
      sm: '0.625rem', // 10px
      md: '1rem',     // 16px
      lg: '1.25rem',  // 20px
      xl: '1.5rem'    // 24px
    },
    padding: {
      page: 'p-4',
      card: 'p-4',
      section: 'p-3'
    },
    gap: {
      xs: 'gap-2',
      sm: 'gap-3',
      md: 'gap-4',
      lg: 'gap-5'
    }
  },
  desktop: {
    // 桌面端样式配置
    fontSize: {
      xs: '0.75rem',    // 12px
      sm: '0.875rem',   // 14px
      base: '1rem',     // 16px
      lg: '1.125rem',   // 18px
      xl: '1.25rem',    // 20px
      '2xl': '1.5rem'   // 24px
    },
    spacing: {
      xs: '0.5rem',   // 8px
      sm: '0.75rem',  // 12px
      md: '1rem',     // 16px
      lg: '1.5rem',   // 24px
      xl: '2rem'      // 32px
    },
    padding: {
      page: 'p-6',
      card: 'p-5',
      section: 'p-4'
    },
    gap: {
      xs: 'gap-2',
      sm: 'gap-3',
      md: 'gap-4',
      lg: 'gap-6'
    }
  }
}

// 组件响应式类名映射
export const componentClasses = {
  // 按钮
  button: {
    mobile: 'px-3 py-1.5 text-sm',
    tablet: 'px-4 py-2 text-base',
    desktop: 'px-4 py-2 text-base'
  },
  // 输入框
  input: {
    mobile: 'px-3 py-2 text-sm',
    tablet: 'px-3 py-2 text-base',
    desktop: 'px-3 py-2 text-base'
  },
  // 卡片
  card: {
    mobile: 'p-3 rounded-lg',
    tablet: 'p-4 rounded-xl',
    desktop: 'p-5 rounded-xl'
  },
  // 标题
  heading: {
    h1: {
      mobile: 'text-xl font-bold',
      tablet: 'text-2xl font-bold',
      desktop: 'text-3xl font-bold'
    },
    h2: {
      mobile: 'text-lg font-bold',
      tablet: 'text-xl font-bold',
      desktop: 'text-2xl font-bold'
    },
    h3: {
      mobile: 'text-base font-bold',
      tablet: 'text-lg font-bold',
      desktop: 'text-xl font-bold'
    }
  },
  // 间距
  spacing: {
    mobile: 'space-y-2',
    tablet: 'space-y-3',
    desktop: 'space-y-4'
  },
  // 网格
  grid: {
    mobile: 'grid-cols-1',
    tablet: 'grid-cols-2',
    desktop: 'grid-cols-3'
  }
}

// 导出默认配置
export default {
  breakpoints,
  deviceStyles,
  componentClasses
}

